import React from 'react';
import { FC, useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import useTranslation from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import ContentTemplate from '@ui/Content/Content';
import Title from '@ui/SectionTitle/Title';
import { publicAssets } from '@utils/url.utils';
import { getImageBaseURL } from '../../constants';
import { Background, ButtonWrapper, Main, PicSource, PicWrapper, Player, Video, Wrapper } from './Gallery.elements';

const GalleryTemplate: FC = () => {
    const { t } = useTranslation();

    const Images = [
        publicAssets('/events1.jpg'),
        publicAssets('/events2.jpg'),
        publicAssets('/events3.jpg'),
        publicAssets('/events4.jpg'),
        publicAssets('/events5.jpg'),
        publicAssets('/events6.jpg'),
        publicAssets('/events7.jpg'),
        publicAssets('/events8.jpg'),
        publicAssets('/events9.jpg'),
        publicAssets('/events10.jpg'),
        publicAssets('/events11.jpg'),
        publicAssets('/events12.jpg'),
        publicAssets('/events13.jpg'),
        publicAssets('/events14.jpg'),
        publicAssets('/events15.jpg'),
        publicAssets('/events16.jpg'),
        publicAssets('/events17.jpg'),
        publicAssets('/events18.jpg'),
        publicAssets('/events19.jpg'),
        publicAssets('/events20.jpg'),
    ];

    const [showAll, setShowAll] = useState(false);
    const [imgFocus, setImgFocus] = useState(false);
    const [imgIndex, setImgIndex] = useState(0);

    const minImgShowCount = 6;

    return (
        <Wrapper>
            <ContentTemplate withPadding mobileSidePadding={20}>
                <Background />
                <Title isBlack>{t('about.gallery.title')}</Title>
                <Main>
                    {Images.map((img, index) => {
                        return showAll || index < minImgShowCount ? (
                            <PicWrapper key={index}>
                                <PicSource
                                    src={img}
                                    onClick={() => {
                                        setImgIndex(index);
                                        setImgFocus(true);
                                    }}
                                />
                            </PicWrapper>
                        ) : null;
                    })}
                </Main>
                <ButtonWrapper>
                    <ButtonTemplate
                        onClick={() => {
                            setShowAll(!showAll);
                        }}
                        text={showAll ? t('about.gallery.showLess') : t('about.gallery.showMore')}
                        whiteType
                    />
                </ButtonWrapper>
                {imgFocus && (
                    <Lightbox
                        mainSrc={Images[imgIndex]}
                        nextSrc={Images[(imgIndex + 1) % Images.length]}
                        prevSrc={Images[(imgIndex + Images.length - 1) % Images.length]}
                        onCloseRequest={() => setImgFocus(false)}
                        onMovePrevRequest={() => setImgIndex((imgIndex + Images.length - 1) % Images.length)}
                        onMoveNextRequest={() => setImgIndex((imgIndex + 1) % Images.length)}
                    />
                )}
            </ContentTemplate>
        </Wrapper>
    );
};

export default GalleryTemplate;
